import { useTranslation } from 'react-i18next';
import { useEffect, useContext, useState } from 'react';
import { IconButton, Button, TEOLoader } from '@teo/components';
import { CrossFilled } from '@teo/components/icons';
import { useGet } from '@/query/fetchHooks';
import { AuthContext } from '@/components/Contexts/AuthContext';
import StepsComponentLP from './StepsComponentLP';
import { useNavigate } from 'react-router-dom';
import { nthIndexOf } from '@/util';

const AddCourseLP = ({
  activeLP,
  setActiveLP,
  setIsOpenAddContent,
  setIsOpenAddContentModal,
  teamInfo,
  student,
  importProgress = false,
}: any) => {
  const { t } = useTranslation();
  const { auth } = useContext(AuthContext);
  const [learningpath, setLearningpath] = useState<any>();

  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [preloader, setPreloader] = useState(false);

  useEffect(() => {
    if (navigateTo) {
      setPreloader(false);
      navigate(navigateTo);
    }
  }, [navigateTo]);

  const navigate = useNavigate();

  const authUser = auth?.user;

  useGet(`/learningpath/${activeLP}`, {
    onSuccess: (result: any) => {
      setLearningpath(result?.data || null);
    },
  });

  // useGet(
  //   activeCourseType !== 'instructions'
  //     ? `/publish/lastversion/${activeCourse}`
  //     : `/coursedetail/${activeCourse}`,
  //   {
  //     courseId: activeCourseType !== 'instructions' && activeCourse,
  //     onSuccess: (result: any) => {
  //       setCourse(result?.data || null);
  //       setPublicationType(result?.data?.publicationCourseType || 'course');
  //     },
  //   }
  // );

  // useGet<any>(`/lpinfo/${activeLP}`, {
  //   onSuccess: (result: any) => {
  //     setLpInfo(result?.data);
  //   },
  // });

  const basePath = window.location.pathname.slice(
    0,
    nthIndexOf(window.location.pathname, '/', 3)
  );

  // if (!course) return null;

  return (
    <div className="fixed top-0 left-0 z-[100] h-screen w-screen overflow-y-auto bg-white">
      {preloader && (
        <div className="fixed inset-0 z-[11] flex bg-white/75">
          <div className="m-auto">
            <TEOLoader
              loaderSrc="/images/TEOloader.gif"
              className="w-[110px]"
            />
          </div>
        </div>
      )}
      <div className="flex min-h-20 flex-col justify-start py-2 pr-2 sm:flex-row sm:items-center">
        <div
          data-testid="clouseBtn"
          className="flex min-h-20 items-center justify-start"
        >
          <IconButton
            className="my-auto mx-3 sm:mx-6"
            Icon={CrossFilled}
            variant="ghost"
            onClick={() => {
              document.body.style.overflow = 'unset';
              setActiveLP && setActiveLP();
              setIsOpenAddContent(false);
            }}
          />
          <div className="flex items-center">
            <div className="mr-5 w-16 min-w-16 sm:w-20 sm:min-w-20">
              <img
                src={
                  learningpath?.lpgroupPicture ||
                  learningpath?.lpPicture ||
                  '/assets/images/LearnPath.png'
                }
                alt={learningpath?.lpName}
                className="inline h-12 w-full rounded-lg object-cover sm:h-14"
              />
            </div>
            <div className="flex flex-wrap">
              <span className="pr-2">
                {t('pages.course_content_flow.header_title')}
              </span>
              <span className="font-semibold">
                {learningpath?.lpgroupName || learningpath?.lpName}
              </span>
            </div>
          </div>
        </div>

        <div className="my-2 ml-12 sm:my-0 sm:ml-auto sm:px-3">
          <Button
            onClick={() => {
              document.body.style.overflow = 'unset';
              setActiveLP();
              setIsOpenAddContent(false);
              setIsOpenAddContentModal(true);
            }}
            variant="ghost"
            size="sm"
          >
            {t('pages.follow_learningpath.change_lp')}
          </Button>
        </div>
      </div>
      {learningpath && (
        <StepsComponentLP
          create={true}
          authUser={authUser}
          // lpInfo={lpInfo}
          learningpath={learningpath}
          teamInfo={teamInfo}
          student={student}
          activeLP={activeLP}
          setIsOpenAddContent={setIsOpenAddContent}
          setActiveLP={setActiveLP}
          onSubmit={(lp: any) => {
            setNavigateTo(`${basePath}/learning-paths/details/${lp.id}`);
            //setIsOpenAddContent(false);
          }}
          setLoader={setPreloader}
          importProgress={importProgress}
        />
      )}
    </div>
  );
};

export default AddCourseLP;
